<template>
  <v-container grid-list-xs class="mt-4" style="width: auto; max-width:1070px" >
    <v-row align="center" justify="center" >
      <v-col cols="12" align="center" >
        <div>
          <h1>Sedes Disponibles</h1>
        </div>
      </v-col> 
    </v-row>

    <v-card flat>
      <v-card-title>
        <h5>Selecciona una sede para mostrar su ubicación:</h5>
      </v-card-title>
      <v-tabs >
        <v-tab v-for="item in itemsSedes" :key="item.mapa">{{item.nombre}}</v-tab>
        <v-tab-item v-for="item in itemsSedes" :key="item.mapa" >
          <v-container>
            <v-row>
              <v-col>
                <v-img :src="item.mapa" contain></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>  
</template>

<script>
import { createForm } from '@/general'
import axios from 'axios';
import { documentosBaseURL }  from '@/general';
export default {
  metaInfo: {
    title: 'Olimpiada de Quimica',
    titleTemplate: 'Sedes - %s',
    htmlAttrs: {
      lang: 'es',
      amp: true
    }
  },
  data: ()=> ({
    itemsSedes: []
  }),

  created(){
    this.getSedes()
  },
   
  methods: {
    async getSedes(){
      let response = await this.sedes()
      if (response.state == '1') {
        delete response['state']
        for(const i in response){
          this.itemsSedes.push({
            nombre: response[i].sede,
            mapa: documentosBaseURL + response[i].mapa_ubicacion,
          })
        }
      }
    },

    sedes(){
      return new Promise((resolve, reject) => {
        axios.post('getSedes.php')
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    }
  }

}
</script>

<style>

</style>